<footer *ngIf="footer$ | async as footer" class="background-dark-blue">
  <div class="footer-top default-block-padding-top">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-4">
          @if(footer.logo){
            <a href="/">
              <img [src]="footer.logo.url" alt="Logo" class="logo" />
            </a>
          }
        </div>
        <div class="col-lg-2">
          <div [innerHTML]="footer.nights | bypassSecurity"></div>
        </div>
        <div class="col-lg-2">
          <div [innerHTML]="footer.sitemap | bypassSecurity"></div>
        </div>
        <div class="col-lg-2">
          <div [innerHTML]="footer.links | bypassSecurity"></div>
        </div>
        <div class="col-lg-2">
          <div [innerHTML]="footer.social | bypassSecurity"></div>
        </div>
      </div>
      <div class="row default-block-padding-top">
        <div class="col-12">
          <div class="border-bottom-box"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-middle">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-2">
            <div [innerHTML]="footer.running | bypassSecurity"></div>
          </div>
          <div class="col-lg-2">
            <div [innerHTML]="footer.walking | bypassSecurity"></div>
          </div>
          <div class="offset-lg-3 col-lg-5">
            <div class="row">
                <div class="col-lg-4" *ngFor="let sponsor of footer.sponsors">
                  <div class="sponsor-logo-container mb-3">
                    <a href="{{ sponsor.url }}" target="{{ sponsor.openInNewTab ? '_blank' : '_self' }}">
                      <img [src]="sponsor.image?.url" [alt]="sponsor.image?.alternativeText" class="img-fluid sponsor-logo" />
                    </a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div class="footer-bottom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          &copy; Copyright {{ currentYear }} - 
          <span [innerHTML]="footer.address | bypassSecurity"></span>
        </div>
        <div class="col-lg-6">
          <div
            class="d-flex justify-content-end"
            [innerHTML]="footer.developedBy | bypassSecurity"
          ></div>
        </div>
      </div>
    </div>
  </div>
</footer>
